<lcs-loading-overlay class="flex-dir-col" [show]="callState | lcsCallState : 'loading'">
  <div [formGroup]="form$ | async" class="auto-attendant-key-form">
    <div class="compact-register-header flex-container space-between">
      <div class="ml-auto">
        @if (canEdit) {
          <button
            class="create-btn"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onCreate()"
            >Add Key</button
            >
          }
        </div>
      </div>
      <lcs-responsive-table [columns]="columns">
        <table
          #table
          lcs-table
          [dataSource]="autoAttendantKeysArray.controls"
          formArrayName="autoAttendantKeysArray"
          class="keys-table"
          >
          <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
          <tr
            lcs-row
            *lcsResponsiveRowDef="let index = dataIndex"
            [hidden]="autoAttendantKeysArray.controls[index].value.isDeleted"
          ></tr>

          <ng-container lcsColumnDef="keyNumber" [width]="2">
            <th lcs-header-cell *lcsHeaderCellDef>Key</th>
            <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
              <mat-form-field class="table-key-input">
                <input type="text" matInput formControlName="keyNumber" [name]="'keyNumber' + index" />
                @if (autoAttendantKeysArray.controls[index]?.hasError('pattern', 'keyNumber')) {
                  <mat-error
                    >Enter key 0-99, *0-*9, or #.</mat-error
                    >
                  }
                  @if (autoAttendantKeysArray.controls[index]?.hasError('unique', 'keyNumber')) {
                    <mat-error
                      >Duplicate keys not allowed.</mat-error
                      >
                    }
                    @if (autoAttendantKeysArray.controls[index]?.hasError('required', 'keyNumber')) {
                      <mat-error
                        >Field is required.</mat-error
                        >
                      }
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container lcsColumnDef="routeToExtension" [width]="8">
                  <th lcs-header-cell *lcsHeaderCellDef>Route To</th>
                  <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                    <mat-form-field class="table-extension-select">
                      <input
                        class="empty-option-placeholder"
                        [lcsSingleSelect]="routeToExtensionSelect"
                        [accountId]="accountId"
                        ndtExtensionSelect
                        type="text"
                        formControlName="routeToExtension"
                        [name]="'routeToExtension' + index"
                        [extensionTypesToExclude]="[7, 11]"
                        (ngModelChange)="handleRouteToExtensionChange(autoAttendantKeysArray.at(index))"
                        />
                        <ndt-extension-select
                          #routeToExtensionSelect
                          [disabled]="!canEdit"
                          [nullActionsToInclude]="nullActions"
                        ></ndt-extension-select>
                        @if (autoAttendantKeysArray.controls[index]?.hasError('required', 'routeToExtension')) {
                          <mat-error
                            >Field is required.</mat-error
                            >
                        }
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container lcsColumnDef="voiceMailOnly" [width]="3">
                    <th lcs-header-cell *lcsHeaderCellDef></th>
                    <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                      <div>
                        <mat-radio-group formControlName="voiceMailOnly" class="radio-group">
                          <div class="radio-container">
                            <mat-radio-button
                              [hidden]="!isExtensionTypePhone(index)"
                              class="table-radio-button"
                              [value]="false"
                              color="primary"
                              (change)="onRadioButtonChange(index, 'voiceMailOnly', $event.value)"
                              >Extension</mat-radio-button
                              >
                              <mat-radio-button
                                [hidden]="!isExtensionTypePhone(index)"
                                class="table-radio-button"
                                [value]="true"
                                color="primary"
                                (change)="onRadioButtonChange(index, 'voiceMailOnly', $event.value)"
                                >
                                Voicemail
                              </mat-radio-button>
                            </div>
                          </mat-radio-group>
                        </div>
                      </td>
                    </ng-container>
                    <ng-container lcsColumnDef="deleteKey" [width]="1.5">
                      <th lcs-header-cell *lcsHeaderCellDef></th>
                      <td lcs-cell *lcsCellDef="let index = dataIndex" [formGroupName]="index">
                        <div class="delete-button-container">
                          @if (extensionPrivileges?.canEditAutoAttendants) {
                            <button
                              mat-icon-button
                              class="delete button"
                              type="button"
                              (click)="onDelete(autoAttendantKeysArray.controls[index].value, index)"
                              >
                              <mat-icon>delete</mat-icon>
                            </button>
                          }
                        </div>
                      </td>
                    </ng-container>
                  </table>
                </lcs-responsive-table>
              </div>
              @if (!autoAttendantKeysArray.controls || autoAttendantKeysArray.controls.length === 0) {
                <span class="no-keys-set"
                  >No Keys Set</span
                  >
                }
              </lcs-loading-overlay>
